import { _ } from "../../polyglot/polyglot.js";
import { configureDialog } from "../dialogs/dialogs.js";
import { notBlank } from "../forms/validators.js";
import AverageDataFormulaNode from "../../../models/keyFigure/formula/AverageDataFormulaNode.js";
import KeyFigure from "../../../models/keyFigure/KeyFigure.js";

/**
 * Create a new driver KeyFigure, and let the user customize it with a
 * dialog. Once the KeyFigure is configured, the callback is used with
 * the new KeyFigure as argument.
 *
 * @param {function(KeyFigure):void} onKeyFigureCreated - Callback
 *   once the KeyFigure is created
 */
export default function openDriverKeyFigureCreationDialog({
	onKeyFigureCreated,
}) {
	const keyFigure = new KeyFigure();
	const node = new AverageDataFormulaNode();
	keyFigure.setFormula(node);

	const dialog = configureDialog({
		title: _("Create driver KPI"),
		formSpec: {
			model: keyFigure,
			saveAction: () => onKeyFigureCreated(keyFigure),
			saveLabel: _("Create driver KPI"),
			dataTestName: "confirm-create",
		},
		formBuilder: makeFormBuilder({ keyFigure }),
	});

	dialog.show();
}

function makeFormBuilder({ keyFigure }) {
	return (form) => {
		form.input({
			accessor: keyFigure.getName.bind(keyFigure),
			mutator: keyFigure.setName.bind(keyFigure),
			label: _("Name"),
			name: "name",
			validator: notBlank(),
		});

		form.input({
			accessor: keyFigure.getSubtitle.bind(keyFigure),
			mutator: keyFigure.setSubtitle.bind(keyFigure),
			label: _("Description"),
			name: "description",
		});

		form.newDropDownField({
			label: _("Value type"),
			name: "valueType",
			accessor: keyFigure.getValueType.bind(keyFigure),
			mutator: keyFigure.setValueType.bind(keyFigure),
			items: KeyFigure.valueTypes(),
			dataTestName: "select-value-type",
		});

		form.textarea({
			label: _("Comment"),
			name: "comment",
			placeHolder: _("Write your comment here"),
			accessor: keyFigure.getDescription.bind(keyFigure),
			mutator: keyFigure.setDescription.bind(keyFigure),
		});
	};
}
